import "font-awesome/css/font-awesome.min.css";

import React, { Component } from "react";
import axios from "axios";
import CryptoJS from "crypto-js";

import { connect } from "react-redux";

import Number from "./ComponentV6/Number";
import Summary from "./Summary/Summary";
import SummaryRTL from "./SummaryRTL/Summary";

import { assessmentActions, questionsActions } from "../../../_actions";
import LogoAssessmentHeader from "../Component/LogoAssessmentHeader";
import AssessmentReport from "../Component/AssessmentReport/AssessmentReport";
import AssessmentReportRTL from "../Component/AssessmentReportRTL/AssessmentReportRTL";
import AssessmentSummary from "../Component/AssessmentSummary/AssessmentSummary";
import AssessmentSummaryRTL from "../Component/AssessmentSummary/AssessmentSummaryRTL";

import moment from "moment";
import Survey from "./Survey";
import SurveyRTL from "./SurveyRTL";



class QuestionPublish extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDisableSubmit: false,

      SurveyCode: this.props.codeValue,

      radioButton: false,
      radioButton2: false,
      currQues: null,
      showWelcomeScreen: true,
      showQuestionScreen: false,
      showThankyouScreen: false,
      instructionPage: false,
      showRedFlag: false,
      saveMsg: "",
      CurrQuesIndex: 1,
      submitSucces: false,

      surveyLanguageName: "English",
      ShowSubmitButton: false,

      textAnswer: "",
      unattemptList: [],
      changeType: "fade",
      mandatoryOn: false,
      afterSubmitData: {
        thankyouText: "",
        bgColor: "",
        bgImage: "",
        textColor: "",
        logo: "",
      },
      alreadySubmitted: false,
      clicked: false,

      showDropdownQues: false,
      dropdownInput: "",
      scrollPosition: 0,
      IpObj: {},
      ShowNotAttempted: false,
      submitMandatory: "",
      setTimeoutRef: "",
      setTimeoutInit: 0,
      disableTimer: false,
      timeCounter: 0,
      setIntervalRef: "",
      showReportModal: false,
      showSummaryReport: false,
      showViewReportThankYouButton: false,
      surveyLanguageCode: 'en',

      themeType: 2,



      showNameEditScreen: false,
      nameFormData: {
        'name': '',
        'email': ''
      },
      errNameForm: {
        'name': '',
        'email': ''
      },


      backSummary: false,
      showMainSummaryModal: false,
      crrDetail: "",
      crrCodeUserDetails: {
        "employeeId": "",
        "name": "",
        "email": "",
        "mobile": "",
        "message": ""
      },
      topFiveTalent: true,
      contactExpertSection: false,
      showMyExpertList: false,
      submitBlock: false


    };


    this.handleShowMainSummaryModal = this.handleShowMainSummaryModal.bind(this);
    this.handleShowMainSummaryModalBack = this.handleShowMainSummaryModalBack.bind(this);
    this.handleExpertContactModalBack = this.handleExpertContactModalBack.bind(this);
    this.handleExpertContactModal = this.handleExpertContactModal.bind(this);
    this.handleInputExpertForm = this.handleInputExpertForm.bind(this);
    this.bookExpert = this.bookExpert.bind(this);
    this.handleExpertClick = this.handleExpertClick.bind(this);


  }

  componentDidMount() {
    this.props.dispatch(questionsActions.emptyReducer());
    if (!window.location.hash) {
      window.location.hash = 'loaded';
      window.location.reload();
    }
    this.props.dispatch(questionsActions.getQuestionList({ code: this.state.SurveyCode }, "v4"));

    // this.props.dispatch(questionsActions.getAssessmentQuestionList({}, "v4"));

    // this.props.dispatch(questionsActions.getAssessmentReport());
    // this.props.dispatch(questionsActions.getAssessmenrEmployeeDetails({}));
    // this.props.dispatch(questionsActions.getAssessmentStatus({}));

    this.props.dispatch(questionsActions.getLanguageLabel());
    this.props.dispatch(questionsActions.getTranslateElementAll());
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.questions.submitfail) {
      return {
        ...nextProps,
        showWelcomeScreen: false,
        showQuestionScreen: false,
        showThankyouScreen: false,
        instructionPage: false,

        alreadySubmitted: true,
      };
    }
    if (nextProps.questions.answerSubmitSuccess) {
      return {
        ...nextProps,
        showWelcomeScreen: false,
        showQuestionScreen: false,
        showThankyouScreen: true,
        instructionPage: false,
      };
    } else {
      return {
        ...nextProps,
      };
    }
  }

  prevQues = () => {
    this.setState({ changeType: "fade1" });
    this.setState({ ShowSubmitButton: false });
    this.setState({ submitMandatory: "" });

    let { questions } = this.props;
    let { questionsList } = questions;

    let { CurrQuesIndex } = this.state;
    if (questionsList && questionsList.length > 0) {
      if (CurrQuesIndex > 1 && CurrQuesIndex < questionsList.length + 1) {
        CurrQuesIndex = CurrQuesIndex - 1;

        this.setState({ CurrQuesIndex }, () => {
          // this.handleSubmitAppear();
        });
      } else {
        this.setState({
          showWelcomeScreen: false,
          showQuestionScreen: false,
          showThankyouScreen: false,
          instructionPage: true,
        });
      }
    }

    // //console.log("answersList: ", answersList)
  };

  nextQues = (type2) => {
    //console.log("Next Question!");
    clearTimeout(this.state.setTimeoutRef);
    clearInterval(this.state.setIntervalRef);

    window.scrollTo(0, 0);

    this.setState({ changeType: "fade", clicked: "" }, () => {
      let { questions } = this.props;
      let { questionsList, surveyScreenData, GroupQuestionOnlyList } =
        questions;

      let { CurrQuesIndex } = this.state;

      // //console.log("<---->------>2");

      let itemQ =
        questionsList && questionsList.length > 0
          ? questionsList[CurrQuesIndex]
          : {};

      ////console.log("itemQ--" + (CurrQuesIndex + 1).toString() + "-->", itemQ);

      //---------------------------- basic ---------------------------------------
      let answersList = [];
      let AnswerListFinal =
        answersList && questions.answersList && questions.answersList.length > 0
          ? questions.answersList
          : [];

      if (questionsList && questionsList.length > 0) {
        if (CurrQuesIndex < questions.questionsList.length) {
          this.props.dispatch(
            questionsActions.handleRecordResTime(
              0,
              itemQ,
              AnswerListFinal,
              questionsList,
              surveyScreenData,
              GroupQuestionOnlyList
            )
          );
        }

        questionsList.forEach((ques) => {
          if (ques.templateId === 13) {
            let getIndex = AnswerListFinal.findIndex(
              (prev) => prev.questionId === ques.id
            );
            if (getIndex !== -1) {
              answersList.push({
                ...AnswerListFinal[getIndex],
                SubQuestionList: ques.SubQuestionList,
              });
            }
          } else {
            let getIndex = AnswerListFinal.findIndex(
              (prev) => prev.questionId === ques.id
            );
            if (getIndex !== -1) {
              answersList.push(AnswerListFinal[getIndex]);
            }
          }
        });
      }
      //-------------------------------------------------------------------
      let isFeedback = false;
      if (questionsList && questionsList.length > 0) {
        if (CurrQuesIndex > 0 && CurrQuesIndex < questionsList.length) {
          //----------------latestcode ---------------------------
          ////console.log("11111111111------>", CurrQuesIndex);

          let questionId =
            questionsList &&
              questionsList[CurrQuesIndex - 1] &&
              questionsList[CurrQuesIndex - 1].id
              ? questionsList[CurrQuesIndex - 1].id
              : "";
          let questionData =
            questionsList &&
              questionsList[CurrQuesIndex - 1] &&
              questionsList[CurrQuesIndex - 1].id
              ? questionsList[CurrQuesIndex - 1]
              : {};
          let flag = 0;

          if (answersList && answersList.length > 0) {
            let getIndex2 = answersList.findIndex(
              (prev) => prev.questionId === questionId
            );
            if (getIndex2 !== -1) {
              let item = answersList[getIndex2];

              //New added feedback
              if (
                item.answer &&
                questionData &&
                questionData.optionsList &&
                questionData.optionsList.length > 0
              ) {
                let optionList = questionData.optionsList;

                let getIndex5 = optionList.findIndex(
                  (prev) => prev.name === item.answer
                );
                if (getIndex5 !== -1) {
                  isFeedback = optionList[getIndex5]["isFeedback"]
                    ? true
                    : false;
                }
              }

              if (item.isMandatory) {
                let template = item.template;

                if (
                  template === 1 ||
                  template === 3 ||
                  template === 4 ||
                  template === 5 ||
                  template === 6 ||
                  template === 16 ||
                  template === 11
                ) {
                  if (!item.answer) {
                    flag = flag + 1;
                  }
                } else if (template === 13) {
                  let isAllAnswered = 0;
                  if (
                    item &&
                    item.SubQuestionList &&
                    item.SubQuestionList.length > 0
                  ) {
                    item.SubQuestionList.forEach((subQues) => {
                      let getIndex2 = AnswerListFinal.findIndex(
                        (prev) => prev.questionId === subQues.id
                      );

                      if (getIndex2 !== -1) {
                        if (
                          AnswerListFinal &&
                          AnswerListFinal[getIndex2] &&
                          AnswerListFinal[getIndex2].multiAnswer &&
                          AnswerListFinal[getIndex2].multiAnswer.length > 1
                        ) {
                          isAllAnswered++;
                        }
                      }
                    });
                  }

                  if (item.SubQuestionList.length !== isAllAnswered) {
                    flag = flag + 1;
                  }
                } else if (template === 2) {
                  if (
                    !(item && item.multiAnswer && item.multiAnswer.length > 0)
                  ) {
                    flag = flag + 1;
                  }
                } else {
                  if (!item.answer) {
                    flag = flag + 1;
                  }
                }
              }
            }
          }

          if (!flag) {
            try {
              let cryptedText = CryptoJS.AES.encrypt(
                JSON.stringify(AnswerListFinal),
                "secretkey123"
              ).toString();
              localStorage.setItem("myAnswers", JSON.stringify(cryptedText));
            } catch (error) {
              //console.log("not saved!");
            }

            ////console.log("isFeedback----------->", isFeedback);

            if (isFeedback && type2 !== 2) {
              this.setState({ showFeedbackModal: true });
            } else {
              CurrQuesIndex = CurrQuesIndex + 1;

              this.setState({ CurrQuesIndex }, () => {
                this.setState({
                  ShowNotAttempted: false,
                  showFeedbackModal: false,
                });

                this.handleSubmitAppear();
              });
            }
          } else {
            this.setState({ ShowNotAttempted: true });
          }

          // //console.log("CurrQuesIndex------>", CurrQuesIndex);
          // //console.log("questionsList.length------>", questionsList.length);
          // //console.log("itemQ------>", itemQ);

          if (itemQ && itemQ.seconds && !this.state.disableTimer) {
            if (CurrQuesIndex < questionsList.length) {
              let setTimeoutRef = setTimeout(
                () => this.nextQues(),
                itemQ.seconds * 1000
              );
              this.setState(
                {
                  timeCounter: itemQ.seconds,
                  setTimeoutRef: setTimeoutRef,
                  setTimeoutInit: moment().unix(),
                },
                () => {
                  let setIntervalRef = setInterval(
                    () =>
                      this.setState({
                        timeCounter:
                          this.state.timeCounter > 0
                            ? this.state.timeCounter - 1
                            : 0,
                      }),
                    1000
                  );
                  this.setState({ setIntervalRef: setIntervalRef });
                }
              );
            } else {
              let setTimeoutRef = setTimeout(
                () => this.saveAnswers(),
                itemQ.seconds * 1000
              );
              this.setState(
                {
                  timeCounter: itemQ.seconds,
                  setTimeoutRef: setTimeoutRef,
                  setTimeoutInit: moment().unix(),
                },
                () => {
                  let setIntervalRef = setInterval(
                    () =>
                      this.setState({
                        timeCounter:
                          this.state.timeCounter > 0
                            ? this.state.timeCounter - 1
                            : 0,
                      }),
                    1000
                  );
                  this.setState({ setIntervalRef: setIntervalRef });
                }
              );
            }
          }
        } else if (CurrQuesIndex === questionsList.length) {
          ////console.log("222222222------>", CurrQuesIndex);

          let questionId =
            questionsList &&
              questionsList[CurrQuesIndex - 1] &&
              questionsList[CurrQuesIndex - 1].id
              ? questionsList[CurrQuesIndex - 1].id
              : "";
          let questionData =
            questionsList &&
              questionsList[CurrQuesIndex - 1] &&
              questionsList[CurrQuesIndex - 1].id
              ? questionsList[CurrQuesIndex - 1]
              : {};

          if (answersList && answersList.length > 0) {
            let getIndex2 = answersList.findIndex(
              (prev) => prev.questionId === questionId
            );
            if (getIndex2 !== -1) {
              let item = answersList[getIndex2];

              //New added feedback
              if (
                item.answer &&
                questionData &&
                questionData.optionsList &&
                questionData.optionsList.length > 0
              ) {
                let optionList = questionData.optionsList;

                let getIndex5 = optionList.findIndex(
                  (prev) => prev.name === item.answer
                );
                if (getIndex5 !== -1) {
                  isFeedback = optionList[getIndex5]["isFeedback"]
                    ? true
                    : false;
                }
              }
            }
          }

          if (isFeedback && type2 !== 2) {
            this.setState({ showFeedbackModal: true });
          }
        }
      }
    });
  };

  submitFeedback = () => {
    let { CurrQuesIndex } = this.state;

    let { questions } = this.props;
    let { questionsList } = questions;

    if (questionsList && questionsList.length > 0) {
      if (CurrQuesIndex === questionsList.length) {
        this.setState({ showFeedbackModal: false }, () => {
          this.handleSubmitAppear();
        });
      } else {
        CurrQuesIndex = CurrQuesIndex + 1;
        this.setState({ CurrQuesIndex }, () => {
          this.setState({ ShowNotAttempted: false, showFeedbackModal: false });
          this.handleSubmitAppear();
        });
      }
    }
  };

  closeFeedbackModal = () => {
    this.setState({ showFeedbackModal: false });
  };

  handleSubmitAppear = () => {
    let { CurrQuesIndex } = this.state;
    let { questions } = this.props;
    let { questionsList } = questions;

    setTimeout(() => {
      if (
        questionsList &&
        questionsList.length > 0 &&
        questionsList.length === CurrQuesIndex
      ) {
        this.setState({ ShowSubmitButton: true });
      } else {
        this.setState({ ShowSubmitButton: false });
      }
    }, 300);
  };

  handleRadio = (Index, ques, currentOption) => {
    this.setState({ clicked: currentOption.id });

    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;

    let { CurrQuesIndex } = this.state;

    if (this.state.radioButton === currentOption.id) {
      this.setState({ radioButton: null });
      this.props.dispatch(
        questionsActions.handleSubmitPreChange(
          ques,
          answersList,
          questionsList,
          "",
          0,
          surveyScreenData,
          "",
          GroupQuestionOnlyList
        )
      );
    } else {
      // //console.log("currentOption----------------------IIIIIIIIIIIIIIIIIIIIIIIII--------------------->",currentOption)
      this.setState({ radioButton: currentOption.id });
      this.props.dispatch(
        questionsActions.handleSubmitPreChange(
          ques,
          answersList,
          questionsList,
          currentOption,
          currentOption.weightage,
          surveyScreenData,
          Index,
          GroupQuestionOnlyList
        )
      );
    }

    this.setState({ radioButton: null });

    // if(!ques.parentId){
    //   setTimeout(()=>this.nextQues(), 300);
    // }
    // setTimeout(()=>this.checkFeedback(), 300);

    let resTime = 0;
    if (this.state.setTimeoutInit) {
      const then = moment.unix(this.state.setTimeoutInit);
      resTime = moment().diff(then, "milliseconds");
    } else {
      resTime = 0;
    }

    this.props.dispatch(
      questionsActions.handleRecordResTime(
        resTime,
        ques,
        answersList,
        questionsList,
        surveyScreenData,
        GroupQuestionOnlyList
      )
    );

    // //console.log("-----questionsListlength---->", questionsList.length);
    // //console.log("-----CurrQuesIndex---->", CurrQuesIndex);

    if (questionsList && questionsList.length > 0 && !this.state.disableTimer) {
      if (questionsList.length - 1 >= CurrQuesIndex) {
        clearTimeout(this.state.setTimeoutRef);
        clearInterval(this.state.setIntervalRef);
      }

      if (CurrQuesIndex === questionsList.length) {
        this.saveAnswers();
      } else if (CurrQuesIndex <= questionsList.length - 1) {
        clearTimeout(this.state.setTimeoutRef);
        clearInterval(this.state.setIntervalRef);
      }
    }

    setTimeout(() => this.nextQues(), 300);
  };

  handleCheckInput = (Index, ques, currentOption) => {
    this.setState({ clicked: currentOption.id });

    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;

    if (true) {
      this.setState({ radioButton: currentOption.id });
      // //console.log("currentOption::", currentOption)
      this.props.dispatch(
        questionsActions.handleSubmitPreChange(
          ques,
          answersList,
          questionsList,
          currentOption,
          currentOption.weightage,
          surveyScreenData,
          "",
          GroupQuestionOnlyList
        )
      );
    }

    // setTimeout(()=>this.nextQues(), 300);
  };

  goToInstructionPage = () => {
    let { questions } = this.props;
    let { surveyScreenData } = questions;

    if (surveyScreenData.isInstruction) {
      this.setState({
        showWelcomeScreen: false,
        showQuestionScreen: false,
        showThankyouScreen: false,
        instructionPage: true,
      });
    } else {
      let { questionsList } = questions;
      let itemQ =
        questionsList && questionsList.length > 0 ? questionsList[0] : {};
      ////console.log("itemQ--01-->", itemQ);

      if (itemQ && itemQ.seconds && !this.state.disableTimer) {
        ////console.log("Seconds--->", itemQ.seconds * 1000);
        let setTimeoutRef = setTimeout(
          () => this.nextQues(),
          itemQ.seconds * 1000
        );
        this.setState(
          {
            timeCounter: itemQ.seconds,
            setTimeoutRef: setTimeoutRef,
            setTimeoutInit: moment().unix(),
          },
          () => {
            let setIntervalRef = setInterval(
              () =>
                this.setState({
                  timeCounter:
                    this.state.timeCounter > 0 ? this.state.timeCounter - 1 : 0,
                }),
              1000
            );
            this.setState({ setIntervalRef: setIntervalRef });
          }
        );
      }

      this.setState({
        showWelcomeScreen: false,
        showQuestionScreen: true,
        showThankyouScreen: false,
        instructionPage: false,
      });
    }
    window.scrollTo(0, 0);
  };

  goToQuestionPage = () => {
    let { questions } = this.props;
    let { questionsList } = questions;
    let itemQ =
      questionsList && questionsList.length > 0 ? questionsList[0] : {};
    ////console.log("itemQ--02-->", itemQ);

    if (itemQ && itemQ.seconds && !this.state.disableTimer) {
      ////console.log("Seconds--->", itemQ.seconds * 1000);
      let setTimeoutRef = setTimeout(
        () => this.nextQues(),
        itemQ.seconds * 1000
      );
      this.setState(
        {
          timeCounter: itemQ.seconds,
          setTimeoutRef: setTimeoutRef,
          setTimeoutInit: moment().unix(),
        },
        () => {
          let setIntervalRef = setInterval(
            () =>
              this.setState({
                timeCounter:
                  this.state.timeCounter > 0 ? this.state.timeCounter - 1 : 0,
              }),
            1000
          );
          this.setState({ setIntervalRef: setIntervalRef });
        }
      );
    }

    this.setState({
      showWelcomeScreen: false,
      showQuestionScreen: true,
      showThankyouScreen: false,
      instructionPage: false,
    });
    window.scrollTo(0, 0);
  };

  saveAnswers() {

    this.setState({ submitBlock: true });

    let { questions } = this.props;
    let { surveyScreenData } = questions;

    if (surveyScreenData) {
      this.setState({
        afterSubmitData: surveyScreenData,
      });
    }

    let survey = {
      code: this.state.SurveyCode,
    };

    //---------------------- new code ------------------------------------------

    let { questionsList } = questions;

    //---------------------------- basic ---------------------------------------
    let answersList = [];
    let AnswerListFinal =
      answersList && questions.answersList && questions.answersList.length > 0
        ? questions.answersList
        : [];

    if (questionsList && questionsList.length > 0) {
      questionsList.forEach((ques) => {
        if (ques.templateId === 13) {
          let getIndex = AnswerListFinal.findIndex(
            (prev) => prev.questionId === ques.id
          );
          if (getIndex !== -1) {
            answersList.push({
              ...AnswerListFinal[getIndex],
              SubQuestionList: ques.SubQuestionList,
            });
          }
        } else {
          let getIndex = AnswerListFinal.findIndex(
            (prev) => prev.questionId === ques.id
          );
          if (getIndex !== -1) {
            answersList.push(AnswerListFinal[getIndex]);
          }
        }
      });
    }
    //-------------------------------------------------------------------

    let { CurrQuesIndex } = this.state;
    if (questionsList && questionsList.length > 0) {
      let flag = 0;
      // //console.log(" CurrQuesIndex=====>: ",CurrQuesIndex," questionsList.length=====>: ", questionsList.length)

      if (CurrQuesIndex > 0 && CurrQuesIndex <= questionsList.length) {
        //----------------latestcode ---------------------------

        let questionId =
          questionsList &&
            questionsList[CurrQuesIndex - 1] &&
            questionsList[CurrQuesIndex - 1].id
            ? questionsList[CurrQuesIndex - 1].id
            : "";

        if (answersList && answersList.length > 0) {
          let getIndex2 = answersList.findIndex(
            (prev) => prev.questionId === questionId
          );
          if (getIndex2 !== -1) {
            let item = answersList[getIndex2];

            if (item.isMandatory) {
              let template = item.template;

              if (
                template === 1 ||
                template === 3 ||
                template === 4 ||
                template === 5 ||
                template === 6 ||
                template === 16 ||
                template === 11
              ) {
                if (!item.answer) {
                  flag = flag + 1;
                }
                // //console.log(" template: ",template," answer: ",item.answer," flag: ",flag)
              } else if (template === 13) {
                let isAllAnswered = 0;
                if (
                  item &&
                  item.SubQuestionList &&
                  item.SubQuestionList.length > 0
                ) {
                  item.SubQuestionList.forEach((subQues) => {
                    let getIndex2 = AnswerListFinal.findIndex(
                      (prev) => prev.questionId === subQues.id
                    );

                    if (getIndex2 !== -1) {
                      if (
                        AnswerListFinal &&
                        AnswerListFinal[getIndex2] &&
                        AnswerListFinal[getIndex2].multiAnswer &&
                        AnswerListFinal[getIndex2].multiAnswer.length > 1
                      ) {
                        isAllAnswered++;
                      }
                    }
                  });
                }

                if (item.SubQuestionList.length !== isAllAnswered) {
                  flag = flag + 1;
                }
              } else if (template === 2) {
                if (
                  !(item && item.multiAnswer && item.multiAnswer.length > 0)
                ) {
                  flag = flag + 1;
                }
              } else {
                if (!item.answer) {
                  flag = flag + 1;
                }
              }
            }
          }
        }

        // //console.log("% ===============> flag1 ==================>",flag)
      }

      if (!flag) {
        if (!this.state.isDisableSubmit) {
          clearTimeout(this.state.setTimeoutRef);
          clearInterval(this.state.setIntervalRef);

          //console.log("Answer Submitted!");

          setTimeout(() => {
            this.setState({ showViewReportThankYouButton: true });
          }, 3000)

          this.props.dispatch(questionsActions.saveAnswers(AnswerListFinal, survey, this.props, this.state.IpObj));
        }
        this.setState({ submitMandatory: "" });
      } else {
        this.setState({
          submitMandatory: "Please attempt mandatory question!",
        });
      }
    }

    // //console.log("% ===============> answersList2 ==================>",answersList)
    // //console.log("% ===============> answersList2 ==================>",answersList)
  }

  ansTextBoxClick(ques) {
    this.setState({ currQues: ques });
  }

  ansTextBoxChange1 = (e, Ques) => {
    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;

    let ansData = {
      _id: "",
      name: e.target.value,
      ans: 1,
    };

    this.setState({ textAnswer: e.target.value });

    // //console.log("ansData; ", ansData)

    this.props.dispatch(
      questionsActions.handleSubmitPreChange(
        Ques,
        answersList,
        questionsList,
        ansData,
        null,
        surveyScreenData,
        "",
        GroupQuestionOnlyList
      )
    );
  };

  handleFeedbackInput = (e, Ques) => {
    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;

    let ansData = {
      name: e.target.value,
    };

    this.setState({ textAnswer: e.target.value });

    // //console.log("ansData; ", ansData)

    this.props.dispatch(
      questionsActions.handleSubmitFeedbackChange(
        Ques,
        answersList,
        questionsList,
        ansData,
        null,
        surveyScreenData,
        "",
        GroupQuestionOnlyList
      )
    );
  };

  ansNPSInput = (val, ques) => {
    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;

    let ansData = {
      _id: "",
      name: val,
      ans: 1,
    };

    this.setState({ textAnswer: val });

    let { CurrQuesIndex } = this.state;

    // //console.log("ansData; ", ansData)

    this.props.dispatch(
      questionsActions.handleSubmitPreChange(
        ques,
        answersList,
        questionsList,
        ansData,
        null,
        surveyScreenData,
        "",
        GroupQuestionOnlyList
      )
    );

    let resTime = 0;
    if (this.state.setTimeoutInit) {
      const then = moment.unix(this.state.setTimeoutInit);
      resTime = moment().diff(then, "milliseconds");

    } else {
      resTime = 0;
    }

    this.props.dispatch(
      questionsActions.handleRecordResTime(
        resTime,
        ques,
        answersList,
        questionsList,
        surveyScreenData,
        GroupQuestionOnlyList
      )
    );

    // //console.log("-----questionsListlength---->", questionsList.length);
    // //console.log("-----CurrQuesIndex---->", CurrQuesIndex);

    if (questionsList && questionsList.length > 0 && !this.state.disableTimer) {
      if (questionsList.length - 1 >= CurrQuesIndex) {
        clearTimeout(this.state.setTimeoutRef);
        clearInterval(this.state.setIntervalRef);
      }

      if (CurrQuesIndex === questionsList.length) {
        this.saveAnswers();
      } else if (CurrQuesIndex <= questionsList.length - 1) {
        clearTimeout(this.state.setTimeoutRef);
        clearInterval(this.state.setIntervalRef);
      }
    }

    // if(!Ques.parentId){
    //   setTimeout(()=>this.nextQues(), 300);
    // }
    setTimeout(() => this.nextQues(), 300);
  };

  ansTextBoxChange2 = (e, Ques) => {
    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;

    let ansData = {
      _id: "",
      name: e.target.value,
      ans: 2,
    };

    this.setState({ textAnswer: e.target.value });

    // //console.log("ansData; ", ansData)

    this.props.dispatch(
      questionsActions.handleSubmitPreChange(
        Ques,
        answersList,
        questionsList,
        ansData,
        null,
        surveyScreenData,
        "",
        GroupQuestionOnlyList
      )
    );
  };

  clickOK = () => {
    // setTimeout(()=>this.nextQues(), 300);
    this.nextQues();
  };

  clickOKLast = (Ques) => {
    // //console.log("clickOKLast; ")

    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;

    let ansData = {
      _id: "",
      name: "",
      ans: 3,
    };

    this.props.dispatch(
      questionsActions.handleSubmitPreChange(
        Ques,
        answersList,
        questionsList,
        ansData,
        null,
        surveyScreenData,
        "",
        GroupQuestionOnlyList
      )
    );

    let { CurrQuesIndex } = this.state;
    if (questionsList && questionsList.length > 0) {
      if (CurrQuesIndex > 0 && CurrQuesIndex < questionsList.length) {
        CurrQuesIndex = CurrQuesIndex + 1;

        this.setState({ CurrQuesIndex });
      }
    }

    let answersList2 = [];
    let AnswerListFinal =
      answersList && questions.answersList && questions.answersList.length > 0
        ? questions.answersList
        : [];
    if (questionsList && questionsList.length > 0) {
      questionsList.forEach((ques) => {
        if (ques.templateId === 13) {
          let getIndex = AnswerListFinal.findIndex(
            (prev) => prev.questionId === ques.id
          );
          if (getIndex !== -1) {
            answersList.push({
              ...AnswerListFinal[getIndex],
              SubQuestionList: ques.SubQuestionList,
            });
          }
        } else {
          let getIndex = AnswerListFinal.findIndex(
            (prev) => prev.questionId === ques.id
          );
          if (getIndex !== -1) {
            answersList.push(AnswerListFinal[getIndex]);
          }
        }
      });
    }

    let flag = 0;
    let unattemptList = [];
    answersList2.forEach((item, index) => {
      if (item.isMandatory) {
        let template = item.template;

        if (
          template === 1 ||
          template === 3 ||
          template === 4 ||
          template === 5 ||
          template === 6 ||
          template === 16 ||
          template === 11
        ) {
          if (!item.answer) {
            flag = flag + 1;
            unattemptList.push(index + 1);
          }
        } else if (template === 13) {
          let isAllAnswered = 0;
          if (item && item.SubQuestionList && item.SubQuestionList.length > 0) {
            item.SubQuestionList.forEach((subQues) => {
              let getIndex2 = AnswerListFinal.findIndex(
                (prev) => prev.questionId === subQues.id
              );
              if (
                AnswerListFinal &&
                AnswerListFinal[getIndex2] &&
                AnswerListFinal[getIndex2].multiAnswer &&
                AnswerListFinal[getIndex2].multiAnswer.length > 1
              ) {
                isAllAnswered++;
              }
            });
            if (item.SubQuestionList.length !== isAllAnswered) {
              flag = flag + 1;
              unattemptList.push(index + 1);
            }
          }
        } else if (template === 2) {
          if (!(item && item.multiAnswer && item.multiAnswer.length > 0)) {
            flag = flag + 1;
            unattemptList.push(index + 1);
          }
        } else {
          if (!item.answer) {
            flag = flag + 1;
            unattemptList.push(index + 1);
          }
        }
      }
    });

    // //console.log("% ===============> answersList ==================>",answersList)

    if (flag) {
      this.setState({ unattemptList: unattemptList });

      if (this.state.mandatoryOn && questionsList && questionsList.length > 0) {
        if (this.state.unattemptList && this.state.unattemptList.length > 0) {
          // //console.log("-----working x")
          this.setState({ CurrQuesIndex: unattemptList[0] });
          // //console.log("-----working x 1")
        }
      }
    } else {
      this.setState({ unattemptList: [] });

      if (this.state.mandatoryOn && questionsList && questionsList.length > 0) {
        // //console.log("All mandatory questions are attempted , now go to last question i.e. submit! ")
        this.setState({ CurrQuesIndex: questionsList.length });
      }
    }

    //nothing
  };

  onMandatoryAttempt = (elem) => {
    this.setState({ CurrQuesIndex: elem });
    this.setState({ mandatoryOn: true });
  };

  gotoSubmit = () => {
    let { questions } = this.props;
    let { questionsList } = questions;

    if (questionsList && questionsList.length > 0) {
      this.setState({ CurrQuesIndex: questionsList.length });
    }
  };

  // handleLanguage = (e) => {
  //   if (e.target.value === "en") {
  //     this.setState({ surveyLanguageCode: "", surveyLanguageName: "" });
  //   } else {
  //     this.setState({
  //       surveyLanguageCode: e.target.value,
  //       surveyLanguageName: "",
  //     });
  //   }
  // };

  openDropdownQuestion = (check) => {
    this.setState({ showDropdownQues: check });
  };

  handleDropdownSelect = (value) => {
    this.setState({ dropdownInput: value, showDropdownQues: false });
  };

  handleMatrixRadio = (ques, subQues, currentOption, items) => {
    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;

    let currIndex2 = answersList.findIndex(
      (element) => element.questionId === subQues.id
    );

    ////console.log('------>answersList------>',answersList)

    this.props.dispatch(
      questionsActions.handleSubmitPreChange(
        ques,
        answersList,
        questionsList,
        currentOption,
        currentOption.weightage,
        surveyScreenData,
        subQues,
        GroupQuestionOnlyList
      )
    );

    // setTimeout(()=>this.nextQues(), 300);
  };

  handleReport = (type) => {
    //console.log("----------type------------->", type)
    if (type === 2) {
      this.props.dispatch(questionsActions.getAssessmentReport({}));
      this.setState({ showReportModal: true });
    } else {
      window.location.reload();
    }
  };

  handleSummaryReport = () => {
    this.props.dispatch(questionsActions.getAssessmentReport({}));
    this.setState({ showSummaryReport: true });
  }

  closeReportModal = () => {
    this.setState({ showReportModal: false });
  };

  closeSummaryReportModal = () => {
    this.setState({ showSummaryReport: false });
  };


  handleLanguage = (item, langList) => {
    //console.log("item------------------->", item)
    if (item.shortName === 'en') {
      this.setState({ surveyLanguageCode: item.shortName, surveyLanguageName: 'English', surveyLanguageRTL: false });
    }
    else {
      this.setState({ surveyLanguageCode: item.shortName, surveyLanguageName: item.name, surveyLanguageRTL: item.isRTL });
    }
  }


  handleDownloadStatus = (reportType) => {
    let data = {
      moduleType: "ASSESSMENT"
    }
    this.props.dispatch(assessmentActions.assessmentDownloadStatus(data));
  }






  loadExpertData = () => {
    let { questions } = this.props;
    let { getAssessmenrEmployeeDetailsData } = questions;
    if (getAssessmenrEmployeeDetailsData && getAssessmenrEmployeeDetailsData.name && getAssessmenrEmployeeDetailsData.email) {
      let eleUser = getAssessmenrEmployeeDetailsData;
      let temp2 = {
        employeeId: eleUser.employeeId,
        name: eleUser.name,
        email: eleUser.email,
        mobile: eleUser.mobile,
      };
      this.setState({ crrCodeUserDetails: temp2 });
    }

    // this.props.dispatch(assessmentActions.getExpertDetailsList());
    // this.props.dispatch(assessmentActions.getExpertOrderBookList());
  }



  handleShowMainSummaryModalBack() {

    this.setState({ showMainSummaryModal: true, showMyExpertList: false, backSummary: false });
  }

  handleShowMainSummaryModal(ele) {

    this.loadExpertData()
    // this.props.dispatch(assessmentActions.userAssessmentExpertOrderEmpty());
    this.setState({ showMainSummaryModal: false, backSummary: true, showMyExpertList: false, crrDetail: ele });
  }

  handleExpertContactModal(ele) {
    // this.props.dispatch(assessmentActions.userAssessmentExpertOrderEmpty());
    this.setState({
      contactExpertSection: ele, topFiveTalent: false
    });
  }

  handleExpertContactModalBack() {
    // this.props.dispatch(assessmentActions.userAssessmentExpertOrderEmpty());
    this.setState({
      contactExpertSection: false, topFiveTalent: true
    });
  }
  handleInputExpertForm(value, name) {
    let { crrCodeUserDetails } = this.state;
    crrCodeUserDetails[name] = value;
    this.setState({ crrCodeUserDetails });
  }

  bookExpert(userDetails, expertDetails) {
    let data = {
      "name": userDetails.name,
      "email": userDetails.email,
      "mobile": userDetails.mobile,
      "message": userDetails.message,
      "expertId": expertDetails.id,
    }
    //console.log("--------->data<---------123123123131-------", data)

    // this.props.dispatch(assessmentActions.userAssessmentExpertOrderPlace(data));

  }

  handleExpertClick() {
    const { history } = this.props;
    history.push('/assessment/expert'); // Replace '/expert-page' with the actual route of your expert page
  }

  viewMyExpert = () => {

    this.loadExpertData()
    // this.props.dispatch(assessmentActions.userAssessmentExpertOrderEmpty());
    this.setState({ backSummary: true, showMyExpertList: true })

  }

  onDownloadAssessmentType2ByEmpID = (emp_id, shortName) => {
    console.log("shortName---->", shortName)
    this.props.dispatch(assessmentActions.getUserAssessmentLangReport({
      "shortName": shortName ? shortName : "en"
    }));
  }


  render() {
    let { questions, onLogout } = this.props;

    let {
      getAssessmentStatusData,
      getAssessmentReportByEmpIDData,
      getAssessmenrEmployeeDetailsData,
      questionsList,
      answersList,
      surveyStatus,
      GroupQuestionOnlyList,
      getRespondantNameData,
      getTranslateElementAllData

    } = questions;

    let { surveyLanguageRTL } = this.state;

    console.log("getTranslateElementAllData------///---------->", getTranslateElementAllData)

    let check =
      getAssessmentStatusData && getAssessmentStatusData.check
        ? getAssessmentStatusData.check
        : 0;

    // let createdAt =
    // getAssessmentStatusData && getAssessmentStatusData.createdAt
    //   ? moment(new Date(parseInt(getAssessmentStatusData.createdAt))).utcOffset("+05:30").format("DD MMMM, YYYY") 
    //   : "";

    let createdAt = "";

    if (getAssessmentStatusData && getAssessmentStatusData.createdAt) {
      const timestamp = parseInt(getAssessmentStatusData.createdAt, 10); // Parse the timestamp

      // Use moment to format the date
      createdAt = moment(timestamp)
        .utcOffset("+05:30")
        .format("DD MMMM, YYYY");
    }

    // //console.log("Formatted Date:", createdAt);
    // //console.log("Raw Timestamp:", getAssessmentStatusData.createdAt);
    // //console.log("Parsed Date:", new Date(parseInt(getAssessmentStatusData.createdAt, 10)));



    let {
      timeCounter,
      setTimeoutInit,
      showFeedbackModal,
      CurrQuesIndex,
      afterSubmitData,
      clicked,
      showDropdownQues,
      IpObj,
      ShowNotAttempted,
      submitMandatory,
      showViewReportThankYouButton,
      showSummaryReport,
      themeType,

      submitBlock

    } = this.state;

    let { UserRespondantName } = this.props;

    let { showReportModal, surveyLanguageCode, surveyLanguageName } = this.state;

    const isMobile = window.innerWidth <= 700;

    ////console.log('isMobile: ',isMobile)

    // //console.log(
    //   "setTimeoutInit:---------------------------------> ",
    //   this.state.setTimeoutInit
    // );
    ////console.log("questionsList:---------------------------------> ", questionsList)
    // //console.log("surveyScreenData:---------------------------------> ", surveyScreenData)
    // //console.log("surveyStatus:---------------------------------> ", surveyStatus)

    let surveyScreenData = {};
    if (questions.surveyScreenData) {
      surveyScreenData = { ...questions.surveyScreenData };
      // surveyScreenData["name"] = "UMatter - Employee Engagement Survey";
      // surveyScreenData["logo"] = "img/companylogo/kotaklogo.png";
      // surveyScreenData["logo2"] = "img/companylogo/umatters.png";

      // if(isMobile){
      //   surveyScreenData["logo2"] = "img/companylogo/kotaklogo2.png";
      // }
      // else{
      //   surveyScreenData["logo2"] = "img/companylogo/kotakbanner.png";
      // }

      // surveyScreenData["logo"] = "img/companylogo/umatters.png";
    }

    let bgImage = "";
    let bgColor = "";
    if (surveyScreenData && surveyScreenData.bgImage) {
      bgImage = "url(" + surveyScreenData.bgImage + ")";
    }

    if (surveyScreenData && surveyScreenData.bgColor) {
      bgColor = surveyScreenData.bgColor;
    }

    // //console.log("CurrQuesIndex: ", CurrQuesIndex);

    // //console.log("showQuestionScreen: ", this.state.showQuestionScreen);
    // //console.log("showWelcomeScreen: ", this.state.showWelcomeScreen);
    // //console.log("showThankyouScreen: ", this.state.showThankyouScreen);

    let welcomeTextDislay = [];
    let instructionTextDislay = [];

    if (surveyScreenData && surveyScreenData.welcomeText) {
      welcomeTextDislay = surveyScreenData.welcomeText;
      instructionTextDislay = surveyScreenData.instructionText;
    }

    ////console.log("welcomeTextDislay: ", welcomeTextDislay);

    let surveytitle = "";
    let bgType = "";

    if (surveyScreenData && surveyScreenData.name) {
      surveytitle = surveyScreenData.name;
      bgType = surveyScreenData.bgType;
    }
    // //console.log("this.state.unattemptList : ", this.state.unattemptList );

    let LabelObj = questions.getLanguageLabelData;
    ////console.log("surveyScreenData: ", surveyScreenData);

    ////console.log("afterSubmitData: ", afterSubmitData);

    ////console.log("surveyStatus: ", surveyStatus);

    let LanguageList = questions.langList;
    ////console.log("LanguageList: ", LanguageList);

    ////console.log("surveyScreenData: ", surveyScreenData);

    function showRadioMatrix(SubQues, option) {
      let getIndex1 = answersList.findIndex(
        (prev) => prev.questionId === SubQues.id
      );
      let getIndex4 = answersList[getIndex1]["multiAnswer"].findIndex(
        (prev) => prev.optionHead === option.heading
      );
      let getIndex3 = answersList[getIndex1]["multiAnswer"].findIndex(
        (prev) => prev.optionId === option.id
      );

      if (getIndex4 !== -1) {
        if (getIndex3 !== -1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }

    function FormatMatriXOptionHeading(question, isOption) {
      let paraObjShow = {};
      if (question && question.optionsList && question.optionsList.length > 0) {
        question.optionsList.forEach((item) => {
          if (paraObjShow && paraObjShow[item.heading]) {
            paraObjShow[item.heading] += 1;
          } else {
            paraObjShow[item.heading] = 1;
          }
        });
      }

      let headingList = [];
      let tempKey = Object.keys(paraObjShow);
      if (tempKey && tempKey.length > 0) {
        tempKey.forEach((item) => {
          headingList.push({
            name: item,
            span: paraObjShow[item],
          });
        });
      }

      if (isOption) {
        let OptionList = [];
        if (headingList && headingList.length > 0) {
          headingList.forEach((heading) => {
            if (
              question &&
              question.optionsList &&
              question.optionsList.length > 0
            ) {
              question.optionsList.forEach((option) => {
                if (heading.name === option.heading) {
                  OptionList.push(option);
                }
              });
            }
          });
        }
        return OptionList;
      } else {
        return headingList;
      }
    }

    function TranslateQuestion(surveyLanguageCode, question) {
      return surveyLanguageCode !== ""
        ? question &&
          question.transl &&
          question.transl[surveyLanguageCode] &&
          question.transl[surveyLanguageCode].name
          ? question.transl[surveyLanguageCode].name
          : question.name
        : question.name;
    }

    function TranslationOptionMatrix(
      question,
      heading,
      surveyLanguageCode,
      type
    ) {
      let optionId = "";
      if (question && question.optionsList && question.optionsList.length > 0) {
        let Index = question.optionsList.findIndex(
          (prev) => prev.heading === heading
        );
        optionId = question.optionsList[Index].id;
      }
      let text =
        surveyLanguageCode !== ""
          ? question &&
            question.transl &&
            question.transl[surveyLanguageCode] &&
            question.transl[surveyLanguageCode].headingList &&
            question.transl[surveyLanguageCode].headingList[optionId]
            ? question.transl[surveyLanguageCode].headingList[optionId]
            : heading
          : heading;

      let arr = text.split("-");
      if (type === 1) {
        return arr && arr[0] ? arr[0] : text;
      }
      if (type === 2) {
        return arr && arr[0] ? arr[0] : text;
      } else if (type === 3) {
        return arr && arr[1] ? arr[1] : "";
      } else {
        return text;
      }
    }

    function TranslationStatementMatrix(question, surveyLanguageCode, type) {
      let text =
        surveyLanguageCode !== ""
          ? question &&
            question.transl &&
            question.transl[surveyLanguageCode] &&
            question.transl[surveyLanguageCode].name
            ? question.transl[surveyLanguageCode].name
            : question.name
          : question.name;

      let arr = text.split("-");
      if (type === 1) {
        return arr && arr[0] ? arr[0] : text;
      }
      if (type === 2) {
        return arr && arr[0] ? arr[0] : text;
      } else if (type === 3) {
        return arr && arr[1] ? arr[1] : "";
      } else {
        return text;
      }
    }

    let { getSurveyTemplateByCodeData } = this.props;
    function SurveyAttributes(name) {
      return surveyLanguageCode !== ""
        ? getSurveyTemplateByCodeData &&
          getSurveyTemplateByCodeData.transl &&
          getSurveyTemplateByCodeData.transl[surveyLanguageCode] &&
          getSurveyTemplateByCodeData.transl[surveyLanguageCode][name]
          ? getSurveyTemplateByCodeData.transl[surveyLanguageCode][name]
          : ""
        : getSurveyTemplateByCodeData && getSurveyTemplateByCodeData[name]
          ? getSurveyTemplateByCodeData[name]
          : "";
    }

    // //console.log('unattemptList', this.state.unattemptList);
    // //console.log('CurrQuesIndex', this.state.CurrQuesIndex);

    // //console.log('answersList:===========>',answersList)

    function MandatoryMsg(Ques) {
      let Text = "";
      let Color = "";
      if (Ques.isMandatory) {
        if (Ques.templateId === 13) {
          Text = SurveyAttributes("allmandatoryText")
            ? SurveyAttributes("allmandatoryText") + "*"
            : "All questions are mandatory*";
          Color = "#eb3434";
        } else {
          Text = "*";
          Color = "#eb3434";
        }
      }
      return {
        text: Text,
        color: Color,
      };
    }

    function showNotCompletedFn(Que) {
      let answersList = [];
      let AnswerListFinal =
        answersList && questions.answersList && questions.answersList.length > 0
          ? questions.answersList
          : [];
      let check = false;
      if (ShowNotAttempted) {
        let getIndex = AnswerListFinal.findIndex(
          (prev) => prev.questionId === Que.id
        );
        if (getIndex !== -1) {
          check =
            AnswerListFinal[getIndex].multiAnswer.length !== 2 ? true : false;
        }
      }

      // //console.log("showNotCompletedFn===>",check)
      return check;
    }

    function CompletedCount() {
      let answerCount = 0;

      //---------------------------- basic ---------------------------------------
      let answersList = [];
      let AnswerListFinal =
        answersList && questions.answersList && questions.answersList.length > 0
          ? questions.answersList
          : [];

      if (questionsList && questionsList.length > 0) {
        questionsList.forEach((ques) => {
          if (ques.templateId === 13) {
            let getIndex = AnswerListFinal.findIndex(
              (prev) => prev.questionId === ques.id
            );
            if (getIndex !== -1) {
              answersList.push({
                ...AnswerListFinal[getIndex],
                SubQuestionList: ques.SubQuestionList,
              });
            }
          } else {
            let getIndex = AnswerListFinal.findIndex(
              (prev) => prev.questionId === ques.id
            );
            if (getIndex !== -1) {
              answersList.push(AnswerListFinal[getIndex]);
            }
          }
        });
      }
      //-------------------------------------------------------------------

      if (questionsList && questionsList.length > 0) {
        questionsList.forEach((Ques) => {
          if (true) {
            //----------------latestcode ---------------------------
            let questionId = Ques && Ques.id ? Ques.id : "";
            let flag = 0;

            if (answersList && answersList.length > 0) {
              let getIndex2 = answersList.findIndex(
                (prev) => prev.questionId === questionId
              );
              if (getIndex2 !== -1) {
                let item = answersList[getIndex2];

                if (true) {
                  let template = item.template;

                  if (
                    template === 1 ||
                    template === 3 ||
                    template === 4 ||
                    template === 5 ||
                    template === 11
                  ) {
                    if (item.answer) {
                      answerCount++;
                    }
                  } else if (template === 6 || template === 16) {
                    if (Number(item.answer)) {
                      answerCount++;
                    }
                  } else if (template === 13) {
                    let isAllAnswered = 0;
                    if (
                      item &&
                      item.SubQuestionList &&
                      item.SubQuestionList.length > 0
                    ) {
                      item.SubQuestionList.forEach((subQues) => {
                        let getIndex2 = AnswerListFinal.findIndex(
                          (prev) => prev.questionId === subQues.id
                        );

                        if (item.isMandatory) {
                          if (getIndex2 !== -1) {
                            if (
                              AnswerListFinal &&
                              AnswerListFinal[getIndex2] &&
                              AnswerListFinal[getIndex2].multiAnswer &&
                              AnswerListFinal[getIndex2].multiAnswer.length > 1
                            ) {
                              isAllAnswered++;
                            }
                          }
                        } else {
                          if (getIndex2 !== -1) {
                            if (
                              AnswerListFinal &&
                              AnswerListFinal[getIndex2] &&
                              AnswerListFinal[getIndex2].multiAnswer &&
                              AnswerListFinal[getIndex2].multiAnswer.length > 0
                            ) {
                              isAllAnswered++;
                            }
                          }
                        }
                      });
                    }

                    if (
                      item.SubQuestionList.length >= isAllAnswered &&
                      isAllAnswered > 0
                    ) {
                      answerCount++;
                    }
                  } else if (template === 2) {
                    if (
                      item &&
                      item.multiAnswer &&
                      item.multiAnswer.length > 0
                    ) {
                      answerCount++;
                    }
                  } else {
                    if (item.answer) {
                      answerCount++;
                    }
                  }
                }
              }
            }
          }
        });
      }

      return answerCount;
    }

    function CompletedCountV1(list) {
      let list2 = [];
      if (list && list.length > 0) {
        list2 = list.filter((prev) => prev.answer !== "");
      }
      //console.log("list2::::", list2);
      if (list2 && list2.length > 0) {
        return list2.length;
      } else {
        return 0;
      }
    }

    let answerCount = CompletedCountV1(answersList);
    //console.log("answerCount::::", answerCount);

    let completedMilestone = answerCount;
    // let completedPercentage = 0;

    // if (questionsList && questionsList.length > 0) {
    //   let num = (answerCount * 100) / questionsList.length;
    //   //console.log("num::::",num)

    //   completedPercentage = (answerCount * 100) / questionsList.length;
    //   if (num >= 25 && num < 50) {
    //     completedMilestone = "25%";
    //   } else if (num >= 50 && num < 75) {
    //     completedMilestone = "50%";
    //   } else if (num >= 75 && num < 100) {
    //     completedMilestone = "75%";
    //   } else if (num >= 100) {
    //     completedMilestone = "100%";
    //   }
    // }

    // let groupQuestionList = []
    // if(questionsList && questionsList.length>0){
    //   questionsList.forEach((item)=>{
    //     if(!(item && item.parentId)){
    //       groupQuestionList.push(item);
    //     }
    //   });
    // }
    ////console.log("GroupQuestionOnlyList---------->",GroupQuestionOnlyList)

    function getGroupIndex(QuesId) {
      ////console.log("QuesId---------->",QuesId)

      if (GroupQuestionOnlyList && GroupQuestionOnlyList.length > 0) {
        let getIndex = GroupQuestionOnlyList.findIndex(
          (prev) => prev.id === QuesId
        );
        if (getIndex !== -1) {
          ////console.log("match---------->",getIndex+1)

          return (getIndex + 1).toString() + ". ";
        } else {
          return "";
        }
      } else {
        return "";
      }
    }

    // //console.log(
    //   "questionsList---------------------------------->",
    //   questionsList
    // );
    //console.log("answersList--------------------- ---->", answersList);

    function functionNameVariable(quesName) {
      return quesName && quesName.toString()
        ? quesName.toString().replace("[variable]", UserRespondantName)
        : quesName;
    }

    function getSecondsToTime(given_seconds) {
      var seconds = parseInt(given_seconds);
      var format =
        (Math.floor(moment.duration(seconds, "seconds").asHours()) < 10
          ? Math.floor(moment.duration(seconds, "seconds").asHours())
          : Math.floor(moment.duration(seconds, "seconds").asHours())) +
        ":" +
        (moment.duration(seconds, "seconds").minutes() < 10
          ? "0" + moment.duration(seconds, "seconds").minutes()
          : moment.duration(seconds, "seconds").minutes()) +
        ":" +
        (moment.duration(seconds, "seconds").seconds() < 10
          ? "0" + moment.duration(seconds, "seconds").seconds()
          : moment.duration(seconds, "seconds").seconds());
      return format;
    }
    //console.log("surveyLanguageCode------------>", surveyLanguageCode);




    const GetTextByLanguage = (name, text) => {
      if (surveyLanguageCode && surveyLanguageCode !== "en") {
        let sentence = "";
        if (getTranslateElementAllData && getTranslateElementAllData.length > 0) {
          let getIndex = getTranslateElementAllData.findIndex(prev => prev.name === name);
          if (getIndex !== -1) {
            sentence = getTranslateElementAllData && getTranslateElementAllData[getIndex] && getTranslateElementAllData[getIndex]["transl"] && getTranslateElementAllData[getIndex]["transl"][surveyLanguageCode] ? getTranslateElementAllData[getIndex]["transl"][surveyLanguageCode] : ""
          }
        }
        //console.log("sentence------------>", sentence);
        console.log("surveyLanguageCode-----aq------->", surveyLanguageCode);
        console.log("getTranslateElementAllData------------>", getTranslateElementAllData);

        return sentence ? sentence : text
      } else {
        return text
      }
    }

    const GetDetailsByLanguage = (element, name, text) => {
      if (surveyLanguageCode && surveyLanguageCode !== "en") {
        let sentence = element && element["details"] && element["details"]["transl"] && element["details"]["transl"][surveyLanguageCode] && element["details"]["transl"][surveyLanguageCode][name] ?
          element["details"]["transl"][surveyLanguageCode][name] : ""
        return sentence ? sentence : text
      } else {
        return text
      }
    }


    function EditButtonFn(name, text) {
      return (
        <>
          {GetTextByLanguage(name, text)}
        </>
      )
    }
    function EditDetailsFn(element, name, text) {
      return (
        <>
          {GetDetailsByLanguage(element, name, text)}
        </>
      )
    }


    function hexToRgbA(hex, opacity) {
      var c;
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split("");
        if (c.length == 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = "0x" + c.join("");
        return (
          "rgba(" +
          [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
          "," +
          opacity +
          ")"
        );
      }
      throw hex;
    }




    function getTheme(field, init) {
      if (themeType === 2) {

        if (field === "backgroundImage") {
          return 'url("/img/survey-light-bg.webp")'
        }
        else if (field === "welcomeImage") {
          return "url('/img/assessment-welcome-large.webp')"
        }
        else if (field === "text") {
          return '#3D405B'
        }
        else if (field === "lightblue") {
          return hexToRgbA('#2196F3', '0.12')
        }
        else if (field === "textblue") {
          return '#2196F3'
        }
        else if (field === "lightblue") {
          return hexToRgbA('#2196F3', '0.12')
        }
        else if (field === "hoverActive") {
          return 'hover:bg-[' + hexToRgbA('#2196F3', '0.12') + '] hover:border-[#2196F3] hover:text-[#2196F3] '
        }
        else if (field === "grayheader") {
          return ' bg-[' + hexToRgbA('#3D405B', '0.05') + '] '
        }
        else if (field === "textOption") {
          return 'border-[#3D405B] text-[#3D405B] '
        }
        else {
          return init
        }

      } else {
        return init
      }
    }

    console.log("surveyLanguageRTL--->", surveyLanguageRTL);



    return (
      <>

        {surveyLanguageRTL ?
          <SurveyRTL
            EditButtonFn={EditButtonFn}
            check={check}
            onLogout={onLogout}
            surveyScreenData={surveyScreenData}
            getAssessmenrEmployeeDetailsData={getAssessmenrEmployeeDetailsData}
            handleReport={this.handleReport}
            surveyLanguageName={surveyLanguageName}
            handleLanguage={this.handleLanguage}
            LanguageList={LanguageList}
            surveyStatus={surveyStatus}
            showWelcomeScreen={this.state.showWelcomeScreen}
            questionsList={questionsList}
            themeType={themeType}
            getTheme={getTheme}
            SurveyAttributes={SurveyAttributes}
            surveyLanguageCode={surveyLanguageCode}
            functionNameVariable={functionNameVariable}
            welcomeTextDislay={welcomeTextDislay}
            goToInstructionPage={this.goToInstructionPage}
            instructionPage={this.state.instructionPage}

            LabelObj={LabelObj}
            instructionTextDislay={instructionTextDislay}
            goToQuestionPage={this.goToQuestionPage}
            afterSubmitData={afterSubmitData}
            showQuestionScreen={this.state.showQuestionScreen}
            submitSucces={this.state.submitSucces}
            getSecondsToTime={getSecondsToTime}

            completedMilestone={completedMilestone}
            CurrQuesIndex={CurrQuesIndex}
            changeType={this.state.changeType}


            answersList={answersList}
            showFeedbackModal={showFeedbackModal}
            closeFeedbackModal={this.closeFeedbackModal}
            handleFeedbackInput={this.handleFeedbackInput}
            submitFeedback={this.submitFeedback}
            clicked={clicked}
            isMobile={isMobile}
            ansNPSInput={this.ansNPSInput}
            nextQues={this.nextQues}
            unattemptList={this.state.unattemptList}
            showRedFlag={this.state.showRedFlag}
            ShowSubmitButton={this.state.ShowSubmitButton}
            submitMandatory={submitMandatory}
            submitBlock={submitBlock}
            saveAnswers={this.saveAnswers}
            showThankyouScreen={this.state.showThankyouScreen}
            showViewReportThankYouButton={showViewReportThankYouButton}
            alreadySubmitted={this.state.alreadySubmitted}

            bgType={bgType}
            bgColor={bgColor}
            timeCounter={timeCounter}
            getGroupIndex={getGroupIndex}
            hexToRgbA={hexToRgbA}
            bgImage={bgImage}
          />
          :
          <Survey
            EditButtonFn={EditButtonFn}
            check={check}
            onLogout={onLogout}
            surveyScreenData={surveyScreenData}
            getAssessmenrEmployeeDetailsData={getAssessmenrEmployeeDetailsData}
            handleReport={this.handleReport}
            surveyLanguageName={surveyLanguageName}
            handleLanguage={this.handleLanguage}
            LanguageList={LanguageList}
            surveyStatus={surveyStatus}
            showWelcomeScreen={this.state.showWelcomeScreen}
            questionsList={questionsList}
            themeType={themeType}
            getTheme={getTheme}
            SurveyAttributes={SurveyAttributes}
            surveyLanguageCode={surveyLanguageCode}
            functionNameVariable={functionNameVariable}
            welcomeTextDislay={welcomeTextDislay}
            goToInstructionPage={this.goToInstructionPage}
            instructionPage={this.state.instructionPage}

            LabelObj={LabelObj}
            instructionTextDislay={instructionTextDislay}
            goToQuestionPage={this.goToQuestionPage}
            afterSubmitData={afterSubmitData}
            showQuestionScreen={this.state.showQuestionScreen}
            submitSucces={this.state.submitSucces}
            getSecondsToTime={getSecondsToTime}

            completedMilestone={completedMilestone}
            CurrQuesIndex={CurrQuesIndex}
            changeType={this.state.changeType}


            answersList={answersList}
            showFeedbackModal={showFeedbackModal}
            closeFeedbackModal={this.closeFeedbackModal}
            handleFeedbackInput={this.handleFeedbackInput}
            submitFeedback={this.submitFeedback}
            clicked={clicked}
            isMobile={isMobile}
            ansNPSInput={this.ansNPSInput}
            nextQues={this.nextQues}
            unattemptList={this.state.unattemptList}
            showRedFlag={this.state.showRedFlag}
            ShowSubmitButton={this.state.ShowSubmitButton}
            submitMandatory={submitMandatory}
            submitBlock={submitBlock}
            saveAnswers={this.saveAnswers}
            showThankyouScreen={this.state.showThankyouScreen}
            showViewReportThankYouButton={showViewReportThankYouButton}
            alreadySubmitted={this.state.alreadySubmitted}

            bgType={bgType}
            bgColor={bgColor}
            timeCounter={timeCounter}
            getGroupIndex={getGroupIndex}
            hexToRgbA={hexToRgbA}
            bgImage={bgImage}
          />}


      </>
    );
  }
}
QuestionPublish.defaultProps = {
  center: { lat: 26.953021, lng: 75.739797 },
  zoom: 15,
};
function mapStateToProps(state) {
  ////console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, users } = state;
  return {
    loggingIn,
    questions,
    users,
  };
}

export default connect(mapStateToProps)(QuestionPublish);
